import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import de from './locales/de';
import en from './locales/en';

void i18n.use(initReactI18next).init({
    fallbackLng: 'de',
    interpolation: {escapeValue: false},
    lng: 'de',
    resources: {
        de: {translation: de},
        en: {translation: en}
    }
});

export default i18n;